import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import "./styles/routeTransferRequest.scss";
import TransferList from "./components/transferList";
import ToggleButtonsTrasnferList from "./components/toogleButtonGroup";

export default function RouteTransferRequest() {
  const [transferList, setTransferList] = React.useState([]);
  const [filter, setFilter] = React.useState("ALL");

  useEffect(() => {
    getRouteTransferList();
  }, []);

  const getRouteTransferList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route-transfer`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setTransferList([...res.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="main-container">
      <div className="route-transfer-container">
        <div className="page-header" style={{ justifyContent: "flex-start" }}>
          <div className="page-heading" style={{ marginLeft: 24 }}>
            Route Transfer Requests
            <div className="page-sub-heading">Create and manage route</div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 10,
              marginLeft: 50,
            }}
          >
            <ToggleButtonsTrasnferList
              alignment={filter}
              setAlignment={(f) => setFilter(f)}
            />
          </div>
        </div>
        <TransferList
          transferList={transferList}
          loadTrasnferList={getRouteTransferList}
          filter={filter}
        />
      </div>
    </div>
  );
}
